/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsIndentArrowLeft: {
  name: 'indent-arrow-left';
  data: string;
} = {
  name: 'indent-arrow-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6 8H1m0 0 2-2M1 8l2 2M1 2h14M1 14h14M9 10h6M9 6h6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
};
